import { module } from 'modujs';

export default class extends module {

    constructor(m) {
        super(m);
        this.form = this.el;
        this.valid = true;
        this.submitButton = this.el.querySelector( "[type=submit]");
        this.formControls = [...this.el.querySelectorAll( '[data-validate]')];
        this.formMessage = this.el.querySelector( '[data-form-message]' );

        this.form.classList.add( 'group' );



        this.submitButton.addEventListener( 'click', e => {

            this.updateMessage( '' );
            if( ! this.validate() ) {
                e.preventDefault();
                e.stopImmediatePropagation();
            } else {
                this.form.classList.add( 'loading' );
            }
        });

        this.form.addEventListener( 'response', this.onResponse.bind( this ) );

        ['wpcf7mailsent', 'wpcf7invalid', 'wpcf7mailfailed', 'wpcf7submit' ].forEach( evt => this.form.addEventListener( evt, this.onCF7Response.bind( this)));

    }

    onCF7Response( e ){
        e.preventDefault();
        this.onResponse( { detail : { success : 'mail_sent' === e.detail.apiResponse.status, message : e.detail.apiResponse.message }})
    }

    onResponse( ev ){
        this.form.classList.toggle( 'success', ev.detail.success && ev.detail.message !== '' );
        this.form.classList.toggle( 'failed', ! ev.detail.success );
        if( ev.detail.success && this.form.dataset.edit !== 'true'){
            this.form.reset();
        }
        this.updateMessage( ev.detail.message );
        this.form.classList.remove( 'loading' );
        this.call( 'update', false, 'Scroll');
    }

    updateMessage( message ){
        if( this.formMessage ){
            this.formMessage.innerHTML = message;
            this.call( 'update', false, 'Scroll');
        }
    }

    validate(){
        this.valid = true;
        this.firstError = false;

        this.formControls.forEach( e => {
            let moduleName = e.dataset.moduleFormControl || e.dataset.moduleCustomSelect ;
            let module = this.modules.FormControl[ moduleName ] || this.modules.CustomSelect[ moduleName ];
            if( module && ! module.validate() ) {
                this.valid = false;
                if( ! this.firstError ) {
                    this.firstError = e;
                    module.input && module.input.focus();
                }
            }
        });

        if( ! this.valid ) {
            let headerHeight = document.querySelector( 'header' ).offsetHeight + 50;
            if(this.firstError.getBoundingClientRect().top < headerHeight){
                this.call('scrollTo', { target: this.firstError, options: { duration: 0.5, offset: -( headerHeight) } }, 'Scroll');
            }
        }
        this.el.dataset.valid = this.valid ? "true" : "false";
        return this.valid;
    }


}
